import { handleActions, createAction } from 'redux-actions';

const getJsonItem = (key) => {
  const value = localStorage.getItem(key);
  try {
    return JSON.parse(value);
  } catch {
    return undefined;
  }
};

const setJsonItem = (key, value) => {
  const data = JSON.stringify(value);
  localStorage.setItem(key, data);
}

const storeName = (str) => str.replace('/SET_', '/');


export default () => {

  const constants = {
    SET_COMPANY: `@SETTINGS/GLOBAL/SET_COMPANY`,
    SET_PI_COMPANIES: `@SETTINGS/GLOBAL/SET_PI_COMPANIES`,
    SET_DN_COMPANIES: `@SETTINGS/GLOBAL/SET_DN_COMPANIES`,
    SET_PO_COMPANIES: `@SETTINGS/GLOBAL/SET_PO_COMPANIES`,
    SET_INV_COMPANIES: `@SETTINGS/GLOBAL/SET_INV_COMPANIES`,
    // FIN-1300: the companies picked in the header of the import queue
    SET_IMPORT_COMPANIES: `@SETTINGS/GLOBAL/SET_IMPORT_COMPANIES`,
    SET_CURRENT_USER: `@SETTINGS/GLOBAL/SET_CURRENT_USER`,
    // FIN-1142: shared across the RL and PO tabs
    SET_BUDGET_YEAR: `@SETTINGS/GLOBAL/SET_BUDGET_YEAR`,
    SET_SELECTED_VESSEL_IDS: `@SETTINGS/GLOBAL/SET_SELECTED_VESSEL_IDS`
  };

  const actions = {
    setCompany: createAction(constants.SET_COMPANY),
    setPiCompanies: createAction(constants.SET_PI_COMPANIES),
    setDnCompanies: createAction(constants.SET_DN_COMPANIES),
    setPoCompanies: createAction(constants.SET_PO_COMPANIES),
    setInvCompanies: createAction(constants.SET_INV_COMPANIES),
    setImportCompanies: createAction(constants.SET_IMPORT_COMPANIES),
    setCurrentUser: createAction(constants.SET_CURRENT_USER),
    setBudgetYear: createAction(constants.SET_BUDGET_YEAR),
    setSelectedVesselIds: createAction(constants.SET_SELECTED_VESSEL_IDS),
  };

  const initialState = {
    company: getJsonItem(storeName(constants.SET_COMPANY)),
    piCompanies: getJsonItem(storeName(constants.SET_PI_COMPANIES)) || [],
    dnCompanies: getJsonItem(storeName(constants.SET_DN_COMPANIES)) || [],
    poCompanies: getJsonItem(storeName(constants.SET_PO_COMPANIES)) || [],
    invCompanies: getJsonItem(storeName(constants.SET_INV_COMPANIES)) || [],
    importCompanies: getJsonItem(storeName(constants.SET_IMPORT_COMPANIES)) || [],
    currentUser: getJsonItem(storeName(constants.SET_CURRENT_USER)) || {},
    budgetYear: getJsonItem(storeName(constants.SET_BUDGET_YEAR)) || new Date().getFullYear(),
    selectedVesselIds: getJsonItem(storeName(constants.SET_SELECTED_VESSEL_IDS)) || [],
  }

  const actionHandlers = {
    [constants.SET_COMPANY]: (state, action) => {
      setJsonItem(storeName(constants.SET_COMPANY), action.payload);
      return { ...state, company: action.payload }
    },
    [constants.SET_PI_COMPANIES]: (state, action) => {
      setJsonItem(storeName(constants.SET_PI_COMPANIES), action.payload);
      return { ...state, piCompanies: action.payload }
    },
    [constants.SET_DN_COMPANIES]: (state, action) => {
      setJsonItem(storeName(constants.SET_DN_COMPANIES), action.payload);
      return { ...state, dnCompanies: action.payload }
    },
    [constants.SET_PO_COMPANIES]: (state, action) => {
      setJsonItem(storeName(constants.SET_PO_COMPANIES), action.payload);
      return { ...state, poCompanies: action.payload }
    },
    [constants.SET_INV_COMPANIES]: (state, action) => {
      setJsonItem(storeName(constants.SET_INV_COMPANIES), action.payload);
      return {...state, invCompanies: action.payload}
    },
    [constants.SET_IMPORT_COMPANIES]: (state, action) => {
      setJsonItem(storeName(constants.SET_IMPORT_COMPANIES), action.payload);
      return { ...state, importCompanies: action.payload }
    },
    [constants.SET_CURRENT_USER]: (state, action) => {
      setJsonItem(storeName(constants.SET_CURRENT_USER), action.payload);
      return { ...state, currentUser: action.payload }
    },
    [constants.SET_BUDGET_YEAR]: (state, action) => {
      setJsonItem(storeName(constants.SET_BUDGET_YEAR), action.payload);
      return { ...state, budgetYear: action.payload }
    },
    [constants.SET_SELECTED_VESSEL_IDS]: (state, action) => {
      setJsonItem(storeName(constants.SET_SELECTED_VESSEL_IDS), action.payload);
      return { ...state, selectedVesselIds: action.payload }
    },

  }

  const reducer = handleActions(actionHandlers, initialState);

  const selector = (state) => ({
    company: state.settings.global.company,
    piCompanies: state.settings.global.piCompanies,
    dnCompanies: state.settings.global.dnCompanies,
    poCompanies: state.settings.global.poCompanies,
    invCompanies: state.settings.global.invCompanies,
    importCompanies: state.settings.global.importCompanies,
    currentUser: state.settings.global.currentUser,
    budgetYear: state.settings.global.budgetYear,
    selectedVesselIds: state.settings.global.selectedVesselIds,
  });

  const mapDispatchToProps = {
    setCompany: (data) => actions.setCompany(data),
    setPiCompanies: (data) => actions.setPiCompanies(data),
    setDnCompanies: (data) => actions.setDnCompanies(data),
    setPoCompanies: (data) => actions.setPoCompanies(data),
    setInvCompanies: (data) => actions.setInvCompanies(data),
    setImportCompanies: (data) => actions.setImportCompanies(data),
    setCurrentUser: (data) => actions.setCurrentUser(data),
    setBudgetYear: (year) => actions.setBudgetYear(year),
    setSelectedVesselIds: (ids) => actions.setSelectedVesselIds(ids),
    fetchPOTotals: createAction("@TOTALS/PURCHASE_ORDERS/FETCH_TOTALS_REQUEST")
  };

  return { constants, actions, initialState, actionHandlers, reducer, selector, mapDispatchToProps };

}
